export const wrapError = (error: unknown): Error => {
  if (!error) throw new Error(`Unknown error`);
  if (error instanceof Error) return error;
  return new Error(`Unknown error ${error.toString()}`);
};
